export default __webpack_public_path__ + "static/media/placeholder-icon.59c6e7aa.svg";